var _defs, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrandmaidle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 405.72 442.15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #5f6060;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n\n      .cls-1, .cls-2, .cls-5 {\n        stroke: #5f6060;\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-3 {\n        fill: #aaa;\n        stroke: #ababab;\n      }\n\n      .cls-4 {\n        fill: #e8e8e8;\n        stroke: #e8e8e8;\n      }\n\n      .cls-5 {\n        fill: #606161;\n      }\n\n      .cls-6 {\n        fill: gray;\n        stroke: gray;\n      }\n\n      .cls-7 {\n        fill: #bebebe;\n        stroke: #bebebe;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Body_Colour",
    "data-name": "Body Colour"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "210.05 228.33 216.71 275.71 251.26 294.81 303.52 279.85 293.75 222.38 236.94 213.02 210.05 228.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M218.42,270.14s22.08,16.4,38.88,12.53,37.2-13.38,39.6-23.51,2.28,181.46,2.28,181.46l-83.81-2.42,3.05-168.06h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M254.01,272.54c7.41.4,10.27-4.38,14.81-7.13s10.78-3.47,12.3-2.72c0,0-12.96,17.56-28.37,17.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M281.23,218.98s15.66,12.96,15.66,18.87c0,12.86,3.73,44.46-2.98,74.02-6.71,29.57,1.98,101.81,0,114.18s43.63-1.78,43.63-1.78c0,0-2.48-56.85-8.69-70.05s3.23-46.54,3.23-46.54c0,0,3.16,8.82,3.78,25.59s9.14,27.14,9.14,27.14c0,0,2.6,23.49,6.69,31.72s0,34.02,0,34.02l50.25-2.1s-11.63-46.66-10.86-58.24l-10.35-12.42s2.26-20.52,1.89-23.7-14.05-33.04-14.05-33.04l1.38-18.89s-14.83-1.22-14.81-9.72c.03-8.5.42-20.1.42-20.1l-12.84-15.24-53.11-18.35-8.38,4.61v.02Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M254.01,272.54c-7.41.4-10.27-4.38-14.81-7.13s-10.78-3.47-12.3-2.72c0,0,12.96,17.56,28.37,17.33"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M226.8,218.98s-15.66,12.96-15.66,18.87c0,12.86-3.73,44.46,2.98,74.02s-1.98,101.81,0,114.18-43.63-1.78-43.63-1.78c0,0,2.48-56.85,8.69-70.05s-3.23-46.54-3.23-46.54c0,0-3.16,8.82-3.78,25.59s-9.14,27.14-9.14,27.14c0,0-2.6,23.49-6.69,31.72s0,34.02,0,34.02l-50.25-2.1s11.63-46.66,10.86-58.24l10.35-12.42s-2.26-20.52-1.89-23.7,14.05-33.04,14.05-33.04l-1.38-18.89s14.83-1.22,14.81-9.72c-.03-8.5-.42-20.1-.42-20.1l12.84-15.24,53.11-18.35,8.38,4.61v.02Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M231.16,228.12s13.75,13.34,17.11,14.43,4.25,10.28,5.34,11.66,2.57-11.86,6.03-11.37,4.77,2.64,4.77,2.64l-1.31,16.15s3.76-4.55,10.48-6.92,20.17-14.23,20.17-14.23c0,0-3.36-10.18-6.62-13.54s-7.12-5.92-7.12-5.92l-51.35-4.01,2.51,11.12h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M230.68,233.95s-12.98,7.32-15.69,25.21l-2.96-5.96s6.29-23.99,9.75-26.66,5.54-4.15,5.54-4.15l3.36,11.57h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M237.22,231.94s4,18.42,0,19.47-8.56.42-8.56.42l14.22,8.42,2.35,3.7s-1.13-19.74-8.01-32.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M286.49,363.15s-3.62,11.83-12.79,5.07-43.33-33.25-52.34-98.08l-9.32-10.98s-5.76,48.6,21.07,84.08,31.66,35.48,39.14,37.65c12.65,3.67,14.24-17.74,14.24-17.74h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M277.56,399.96s-10.14-9.17-30.17-15.93c-20.03-6.76-26.03-63.79-26.03-63.79l-2.94-.23s1.15,38.92-1.44,58.96c0,0-3.62,31.13,0,44.41s53.58,1.93,53.58,1.93c0,0-40.31-11.34-35.72-19.55s42.72-5.79,42.72-5.79h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173.88,277.67s-4.76,19.82-11.37,21.67c0,0-3.06,37.81-6.16,39.13s-8.65-3.7-8.65,4.49,1.06,11.1,1.06,15.33-2.64,6.08-2.38,15.07c0,0-16.39-12.95-18.24-21.94,0,0-6.81,6.32-6.05,10.17s16.42,25.79,15.99,32.66,1.42,23.79-4.13,26.96h22.39s-1.93-24.05,0-29.08,6.42-21.15,6.69-31.72c0,0,6.16-7.11,8.02-29.55l7.82-18.59,1.75,32.27,8.5-40.29s-4.28,12.6-5.55,7.75-3.64-25.52-9.69-34.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M318.72,302.44l-4.88-17.09s9.32,26.42,11.99,21.98,5.11-14.65,5.11-14.65l-3.11,52.62-9.1-42.85h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M332.48,283.57s1.78,19.31,5.11,23.98c0,0,6.27-1.42,5.88-17.75-.02-.78-.05-1.6-.1-2.45-1.11-18.65,7.1,23.09-1.33,43.74,0,0,2.89,5.55,2.89,9.32s-.89,18.87,3.55,24.87c0,0-.94,12.54-1.09,20.43,0,.7-.02,1.37-.02,1.99,0,7.55-8.44-38.63-9.55-49.95s-7.99-25.53-7.99-25.53l2.66-28.64h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M356.13,263.96s1.41,5.04-1.12,13.7,6.46,19.06,6.46,22.72,4.78,8.15-1.41,22.77-6.61,13.77-11.6,28.11c0,0,12.44-23.84,17.22-23.02,0,0,.28,10.09,2.53,13.19s4.18,6.15,4.22,11.52c.15,21.96-16.02,24.49-15.46,35.57s20.8-9.15,23.89-15.05c0,0-7.59,15.46-6.46,25.86s16.3,13.21,16.3,22.21l10.68-1.12s-10.12-37.66-10.4-52.28l-11.24-14.9,3.65-23.61s-12.37-9.84-14.33-35.13l1.12-14.9s-10.96,1.92-14.05-15.62v-.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M313.29,222.38s-11.3,1.05-13.29,7.97-4.74,11.05-4.74,11.05c0,0-3.06-12.83-10.54-19.02l-3.06-4.66,7.64-3.36,23.98,8.02h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M206.58,217s11.91-.75,12.37,4.01-3.95,14.25-3.95,14.25c0,0,3.07-11.7,8.68-13.56s2.16-4.7,2.16-4.7l-7.42-3.98-11.85,3.98h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Body_Lines",
    "data-name": "Body Lines"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M273.35,225.55s-11.78,17.15-11.7,39.87c0,0,2.91-3.76,4.36-5.15s16.46-6.15,27.9-17.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M281.23,217s-7.61,16.86-2.73,26.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M281.23,221.01s5.32,2.86,9.58,9.34c4.25,6.48,12.28,37.9,2.6,76.64s3.48,78.59-.37,112"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M288.17,212.03s51.36,19.16,54.54,20.68,13.58,10.86,14.85,16.16-1.7,13.58,0,19.73,12.09,7.43,13.58,10.4-6.37,36.5-12.31,49.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M369.94,291.96s5.13,26.41,13.62,36.28c3.07,3.57-1.17,20.37-.95,24.19s8.91,10.19,8.91,15.7,5.96,37.81,10.41,53.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M342.86,234.05s-7.45,39.79-13.11,53.06c0,0-1.64,56.81-.5,68.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M318.91,304.25c-.44-1.65,3.47,28.81,10.33,51.31,4.5,14.75,8.29,63.43,8.29,63.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M329.75,314.83s5.85,12.56,6.1,18.44,2.21,22.29,7.01,27.76c0,0,1.35,23.79,7.22,33.68,0,0,2.23,12.32,1.42,24.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.01,281.13c26.03,0,41.7-20.66,42.87-28.44"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M234.68,225.55s11.78,17.15,11.7,39.87c0,0-2.91-3.76-4.36-5.15s-16.46-6.15-27.9-17.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M226.8,217s7.61,16.86,2.73,26.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M226.8,221.01s-5.32,2.86-9.58,9.34-12.28,37.9-2.6,76.64-3.48,78.59.37,112"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.86,212.03s-51.36,19.16-54.54,20.68-13.58,10.86-14.85,16.16,1.7,13.58,0,19.73-12.09,7.43-13.58,10.4,6.37,36.5,12.31,49.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M138.08,291.96s-5.13,26.41-13.62,36.28c-3.07,3.57,1.17,20.37.95,24.19s-8.91,10.19-8.91,15.7-5.96,37.81-10.41,53.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M165.17,234.05s7.45,39.79,13.11,53.06c0,0,1.64,56.81.5,68.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M189.11,304.25c.44-1.65-3.47,28.81-10.33,51.31-4.5,14.75-8.29,63.43-8.29,63.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M178.28,314.83s-5.85,12.56-6.1,18.44-2.21,22.29-7.01,27.76c0,0-1.35,23.79-7.22,33.68,0,0-2.23,12.32-1.42,24.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M254.01,281.13c-26.03,0-41.7-20.66-42.87-28.44"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Head_Colour",
    "data-name": "Head Colour"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M186.24,185.3s-2.51,8.92-.88,12.05,6.91,9.42,13.44,5.4,10.41-7.22,10.41-7.22c0,0,2.82,10.11,6.88,12.49s13.48,9.67,13.48,9.67l11.3,11.3,15.57,1.88,14.44-4.4,9.92-12.31,14.69-10.8s12.93-.38,14.44-1.25,5.15-15.11,5.15-15.11l3.77-4.1s12.47-3.26,12.18-8.54-2.51-7.28-2.51-7.28c0,0,6.78,1.13,9.8-2.13s4.19-5.39,3.64-10.78c0,0-.63,6.64-5.78,6.64s-8.04.4-7.79-5.64-.38-13.45-.38-13.45c0,0,9.17-10.93,8.66-14.82s-4.52-7.58-10.17-12.68-3.6-8.87-3.6-8.87c0,0,2.47-5.96,5.73-5.57,0,0-6.14-2.3-9.78-2.26,0,0,1.9-12.06,0-14.69s-9.6-8.67-17.35-7.03-12.68,8.04-12.68,8.04l-7.66-1.76.88-11.05,8.79-1.1,3.27,1.86-4.65-8.92-13.44-1.76-7.79,4.02-4.82-11.3-3.98-.63-.5,9.29s-16.57,2.72-23.99,2.13c-12.81-1-17.2,17.83-17.2,17.83l-9.29-2.36s-8.13-.91-13.23,5.75c-5.1,6.66-7.53,11.2-7.24,16.58s1.26,6.4,1.26,6.4c0,0-11.68-1.51-15.2,3.77-3.52,5.28.38,15.07,3.77,19.34s3.14,10.55-3.39,11.43-12.18-4.14-12.18-4.14c0,0,0,7.41,3.39,9.67s11.55.13,11.55.13c0,0-7.47,8.63-10.8,13.3s-5.02,15.37,2.01,17.48c7.03,2.11,17.83,5.51,17.83,5.51h.03Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M282.81,176.35s-2.1,7.72,0,12.06,5.5,12.48,1.18,16.02-7.12-5.93-7.12-5.93l-8.03,3.96s8.32-.72,8.59,2.53-5.24,20.55-5.24,20.55c0,0,8.33-9.1,10.59-10.91,11.42-9.16,16.96-20.55,19.37-31.22,0,0-10.21,17.96-10.21,14.15,0-2.62-9.17-13.17-9.13-21.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M296.16,155.74s-14.25,7.97-27.33,4.32c0,0,12.34,3.49,19.64.59,6.59-2.62,7.69-4.91,7.69-4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M317.7,160.64s-.16,8.01-1.4,10.89-5.14,8.8-7.47,8.8c0,0,5.06-6.93,5.06-8.25s-1.71-11.6-.62-12.93,3.5-2.18,3.5-2.18c0,0,.93,3.67.93,3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M291.57,161.74s1.49,10.56-.8,15.84c0,0,1.41,5.16,1.28,7.12,0,0,3.59-2.07,4.08-8.34.24-3.04-.82-6.56-1.98-9.39-.32-.78,4.9-2.25,5.7-4.7.49-1.49-3.21-4.36-3.38-4.7-.62-1.22-4.9,4.17-4.9,4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M254.01,186.65s6.59-3.41,10.07-1.96,3.28,3.03,3.28,3.03c0,0-9.26,3.39-13.35,3.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M261.84,121.48s-6.04,5.66-4.7,9.48,5.02,3.9,5.02,3.9c0,0-4.76-5.54-.32-13.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M267.48,113.92s-5.81,4.34-13.47,3.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M225.22,176.35s2.1,7.72,0,12.06-5.5,12.48-1.18,16.02,7.12-5.93,7.12-5.93l8.03,3.96s-8.32-.72-8.59,2.53,5.24,20.55,5.24,20.55c0,0-8.33-9.1-10.59-10.91-11.42-9.16-16.96-20.55-19.37-31.22,0,0,10.21,17.96,10.21,14.15,0-2.62,9.17-13.17,9.13-21.21h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M211.87,155.74s14.25,7.97,27.33,4.32c0,0-12.34,3.49-19.64.59-6.59-2.62-7.69-4.91-7.69-4.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M190.33,160.64s.16,8.01,1.4,10.89,5.14,8.8,7.47,8.8c0,0-5.06-6.93-5.06-8.25s1.71-11.6.62-12.93-3.5-2.18-3.5-2.18c0,0-.93,3.67-.93,3.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M216.46,161.74s-1.49,10.56.8,15.84c0,0-1.41,5.16-1.28,7.12,0,0-3.59-2.07-4.08-8.34-.24-3.04.82-6.56,1.98-9.39.32-.78-4.9-2.25-5.7-4.7-.49-1.49,3.21-4.36,3.38-4.7.62-1.22,4.9,4.17,4.9,4.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M254.01,186.65s-6.59-3.41-10.07-1.96-3.28,3.03-3.28,3.03c0,0,9.26,3.39,13.35,3.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M246.18,121.48s6.04,5.66,4.7,9.48-5.02,3.9-5.02,3.9c0,0,4.76-5.54.32-13.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M240.54,113.92s5.81,4.34,13.47,3.9"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M265.45,134.86s-6.98,9.16-6.98,10.62-1.51,20.92-1.13,24.06,3.52,9.16,2.89,11.55-6.21,5.56-6.21,5.56c0,0,12.49,3.23,13.87-.29s1.91-5.71,1.91-5.71c0,0-8.06-10.69-6.3-23.08l16.2-7.02s-7.03-2.73-1.17-16.63c.21-.49.25-1.03.41-1.52,2.39-7.31-13.48,2.46-13.48,2.46h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M287.26,131.65s4.62,9.81,9.39,15.7-1.82,12.71-1.82,12.71l-4.48,19.73s1.54,9.18,0,12.41,5.05,2.74,5.05,2.74c0,0-2.16,9.58,2,9.37s13.83,2.18,14.53-4.69,4.48-15.29,4.48-15.29c0,0,12.05-3.49,12.89-6.71s0-10.37,0-10.37c0,0,9.39,1.82,11.07-3.22s2.24-10.28,2.24-10.28c0,0-3.5,7.67-7.99,7.44s-6.17-1.08-6.03-9.56-.56-10.72-.56-10.72c0,0,7.85-1.68,7.85-10.09s-3.37-13.04-5.64-15.31-6.49-8.48-6.49-8.48c0,0-3.7,15.99-11.41,14.14s-8.26-13.37-8.26-13.37c0,0-14.87,13.07-17.81,8.02s-1.69-10.46-1.69-10.46c0,0,3.98-6.31,3.68-8.32,0,0-5.32,2.92-10.51-1.28-2.25,6.59-7.68,9.9-13.34,12.97,0,0,.54,16.52,7.99,16.24s14.86,6.69,14.86,6.69h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M262.26,109.27s-13.26,4.25-16.4,5.11-9.41.86-10.95,2.18c-7.57,6.52,7.71,3.83,11.27,4.93-3.78-1-18.51,2.14-18.92,4.06-.41,1.93-4,17.09-10.88,16.79-6.87-.3-17.18,4.71-17.18,4.71v-9.16s19.45-4.18,20.19-12.92,2.63-16.32,6.96-15.69,9.45,5.11,9.45,5.11c0,0,1.59-8.37,6.82-8.09s12.56,5.2,19.64,2.98h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M232.47,85.01s-3.32,9.25,1.44,14.17,8.71,7.11,8.71,7.11l-8.81,6.54-7.47-5.04s.19-5.68-3.19-10.76-9.02-6-13.95-4.61-4.63-12.33,6.92-10.96c0,0-1.05,5.43,5.14,5.74,6.19.31,11.2-2.19,11.2-2.19h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M190.96,111.5l-3.95-10.62s2.94,6.57,7.23,4.47,5.69,3.21,5.69,3.21c0,0-1.2,11.45-4.69,11.29s-4.28-8.35-4.28-8.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M188.23,114.38s-5.93,25.42-4.84,27.96,3.61,4.71,3.61,4.71c0,0,1.38-2.71,2.66-2.71s7.1,3.28,7.1,3.28l2.43-10.61c-18.54-12.03,4.06-23.07-10.97-22.62h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M192.1,184.69s-2.54,14.87,1.27,16.25,9.97.15,9.97.15l4.8-4.05-1.83-6.9s-5.11,6.12-7.56,2.89-6.65-8.34-6.65-8.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M244.72,84.35s-2.95,1.66-.71,6.74,13.49,5.59,14.11,2.14,1.24-9.86-2.42-10.37-10.98,1.49-10.98,1.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M273.81,76.84l2.33,2.45h4.89s.12-8.65,3.96-8.81,11.15,2.75,11.15,2.75c0,0-3.7-9.9-9.4-10.95-5.71-1.05-16.58-1.4-24.48,6.29l11.55,8.27h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M290.82,80.44s10.95-6.51,17.82-4.07,11.18,7.3,11.18,12.03-.95,7.35-.95,7.35c0,0-11.45,2.78-13.11,7.41,0,0,1.68-12.46-3.54-16.42s-11.4-6.3-11.4-6.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M257.62,61s3.28-1.39,4.64.72c1.28,1.98.35,5.25-.23,5.52l6.16-5.23s-3.87-7.7-8.73-8.82c0,0,1.59,6.36-1.84,7.81h0Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Head_Lines",
    "data-name": "Head Lines"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M264.53,187.18s-1.74-.84-4.09,1.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M309.95,136.88s.9,6.78,0,13.64-3.25,24.39-7.23,32.88c-3.97,8.49-3.25,17.26-7.04,21.9s-14.45,11.69-14.45,11.69c0,0-9.57,11.2-13.01,12.82s-10.35,2.89-14.21,2.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M268.83,190.14s13.63,11.33,13.35,15.17-3.16,6.73-3.16,6.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M276.28,198.5s-14.42,5.17-22.27,4.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M292.06,160.64s5.24,8.31,5.06,12.46-1.08,6.68-1.08,6.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.21,157.57s5.42,8.67,7.04,9.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M286.76,161.18s-1.56.72-4.58,1.09-14.03-2.21-14.03-2.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M298.82,153.65s-8.2-4.1-16.63-3.71-17.65,7.63-17.65,7.63c0,0,15.98-5.27,19.69-5.27s14.6,1.35,14.6,1.35h-.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M278.6,145.68s-11.62,2.22-14.07,11.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M261.5,124.96s-3.15,6.75.67,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M265.15,145.68c-3.93,1.43-5.3,3.01-4.71,5.95s1.96,13.3,4.96,14.5,30.98,4.07,36.33-3.25,6.94-13.91,5.35-17.19-26.85-5.49-41.93,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M254.01,152.35c4.05,0,6.26,1.82,6.26,1.82l-.7-2.45s-3.24-1.17-5.56-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M310.35,149.15s5.55-4.68,8.73-3.48,7.39,18.03,2.62,27.36c-4.77,9.33-13.37,24.18-19.97,15.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M318.36,160.05s-.73-5.46-2.93-4.1-5.55,7.02-3.25,15.19c1.06,3.77-2.24,5.39-4.08,8.65"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M243.5,187.18s1.74-.84,4.09,1.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M198.08,136.88s-.9,6.78,0,13.64,3.25,24.39,7.23,32.88c3.97,8.49,3.25,17.26,7.04,21.9s14.45,11.69,14.45,11.69c0,0,9.57,11.2,13.01,12.82s10.35,2.89,14.21,2.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M239.2,190.14s-13.63,11.33-13.35,15.17,3.16,6.73,3.16,6.73"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M231.75,198.5s14.42,5.17,22.27,4.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M215.96,160.64s-5.24,8.31-5.06,12.46,1.08,6.68,1.08,6.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.82,157.57s-5.42,8.67-7.04,9.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M221.27,161.18s1.56.72,4.58,1.09,14.03-2.21,14.03-2.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.21,153.65s8.2-4.1,16.63-3.71,17.65,7.63,17.65,7.63c0,0-15.98-5.27-19.69-5.27s-14.6,1.35-14.6,1.35h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M229.43,145.68s11.62,2.22,14.07,11.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M246.53,124.96s3.15,6.75-.67,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M242.88,145.68c3.93,1.43,5.3,3.01,4.71,5.95s-1.96,13.3-4.96,14.5-30.98,4.07-36.33-3.25-6.94-13.91-5.35-17.19,26.85-5.49,41.93,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M254.01,152.35c-4.05,0-6.26,1.82-6.26,1.82l.7-2.45s3.24-1.17,5.56-1.17"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M197.68,149.15s-5.55-4.68-8.73-3.48-7.39,18.03-2.62,27.36c4.77,9.33,13.37,24.18,19.97,15.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M189.67,160.05s.73-5.46,2.93-4.1,5.55,7.02,3.25,15.19c-1.06,3.77,2.24,5.39,4.08,8.65"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.9,132.89s23.14-2.07,30.67,1.03c0,0,.34-4.9-.67-5.68s-23.5,1.6-23.5,1.6l-6.5,3.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.21,133.4s-29.19-2.58-36.71.52c0,0-.34-4.9.67-5.68s28.77,2.35,28.77,2.35l7.27,2.82h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M269.34,63.11c-3.03-14.7-12.43-10.76-12.43-10.76,8.49,17.13-15.92,7.43-29.41,12.43-7.06,2.62-11.37,16.68-11.37,16.68,0,0-12.4-7.86-23.21,4.83s-4.63,21.5-4.63,21.5c0,0-16.81-1.95-17.15,10.4-.34,12.35,12.35,14.92,4.63,22.47s-14.58-5.32-14.58-5.32c0,0-4.97,22.47,15.43,14.75,0,0-19.38,15.43-13.2,25.9,6.18,10.47,22.25,9.78,22.25,9.78,0,0-5.78,10.29,1.93,16.98s18.77-1.36,21.34-4.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M258.12,70.54s13.95-11.52,22.89-10.76,16.22,4.55,15.01,16.07c0,0-2.88-5.76-9.1-4.09s-4.55,8.34-4.55,8.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M290.26,80.09s5.72-6.45,17.13-5.31c10.61,1.06,16.07,7.58,13.04,19.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M248.77,95.28s16.28,2.25,10.56-9.18-15.41-1.76-15.41-1.76c4.33-15.78,20.76-18.51,30.13-6.04,9.37,12.47-1.14,27.62-8.3,29.11-14.2,2.94-15.42-1.23-22.18-1.75s-8.66,8.83-8.66,8.83c0,0-3.76-7.29-10.27-5.57s-4.12,17.66-10.12,21.61-14.06,9.78-21.78,4.12-13.2-17.28-1.78-23.15c0,0-3.05,15.16,6.07,8.57,6.87-4.96,0-14.67,5.14-21.74s14.58-7.69,19.21-4.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M277.76,81.46s13.61-3.15,22.44,4.64c8.83,7.79,6.06,33.77-10.39,36.02s-22.25-4.5-25.76-14.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M284.59,88.87s7.64,8.14.89,14.72-16.14,3.46-16.14,3.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M305.13,106.62s13.74-19.98,27.48-5.76c0,0-15.07-2.53-12.53,22.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M293.45,121.16s1.91,17.8,23.92,11.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M322.92,105.35s3.94,8.72,9.69,11.77c5.75,3.05,8.97,13.88-3.22,25.23,0,0,2.71,2.03.93,11.34s10.92,7.62,11.09-4.91c0,0,9.82,18.79-10.67,20.32,0,0,8.47,10.16-13.38,16.25,0,0-2.54,4.23-3.39,13.38s-16.59,5.59-16.59,5.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M251.01,72.47s-14.16,0-20.03,15.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M234.92,114.5s-4.27-.99-9.07,2.67c-4.8,3.66-9.46,11.42-9.46,11.42"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrandmaidle);
export default __webpack_public_path__ + "static/media/grandma idle.32169319c8f6242c98231ecfad801dfc.svg";
export { ForwardRef as ReactComponent };